import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { EntityId } from '@reduxjs/toolkit'
import { RootState } from '@store/store'
import { newsExtraReducers } from '@store/reducres/news.reducers'

export const newsUrl = 'news'

export enum NewsState {
  IN_PROGRESS = 0,
  TO_REVIEW = 1,
  REVIEW_OK = 2,
  PUBLISHED = 3,
  ERROR = -1,
}

export interface NewsModel extends DjangoModel {
  areaId: EntityId
  stationId: EntityId
  audioId: EntityId
  visualId: string
  content: string
  state: NewsState
  note: string
  section: string
  date: string
  lockedAt: string | null
  lockedBy: string | null
}

const {
  slice: newsSlice,
  thunks: newsThunks,
  adapter: newsAdapter,
  selectors,
} = createGenericSlice<NewsModel>('news', newsUrl, {}, newsExtraReducers)

export const newsAdapterExport = newsAdapter

export const {
  fetchAll: fetchAllNewss,
  create: createNews,
  update: updateNews,
  delete: deleteNews,
} = newsThunks
export const { selectAll: selectAllNews, selectById: selectNewsById } =
  newsAdapter.getSelectors<RootState>((state: RootState) => state.news)

export const { removeAll: clearAllNews } = newsSlice.actions

export const {
  selectLoading: selectNewsLoading,
  selectIsIdInProgress: selectIsNewsIdInProgress,
  selectError: selectNewsError,
} = selectors

export default newsSlice.reducer
